import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isAllLoading: false,
  isSuccess: false,
  messageData: [],
  allMessageData: [],
  error: '',
}

export const getStudentMessage = createAsyncThunk(
  'message/getStudentMessage',
  async ({ MATRICULE, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res = await request(token).get(`/students/studentMessage`, {
        params: {
          MATRICULE,
        },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      toast.error(message)

      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const getAllMessages = createAsyncThunk(
  'message/getAllMessages',
  async ({ MATRICULE, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res = await request(token).get(`/students/allMessages`, {
        params: {
          MATRICULE,
        },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      toast.error(message)

      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStudentMessage.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getStudentMessage.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          messageData: action.payload,
          error: '',
        }
      })
      .addCase(getStudentMessage.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(getAllMessages.pending, (state) => {
        return {
          ...state,
          isAllLoading: true,
        }
      })
      .addCase(getAllMessages.fulfilled, (state, action) => {
        return {
          ...state,
          isAllLoading: false,
          isSuccess: true,
          allMessageData: action.payload,
          error: '',
        }
      })
      .addCase(getAllMessages.rejected, (state, action) => {
        return {
          ...state,
          isAllLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
  },
})

export default messageSlice.reducer
